import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import HeadingIcon from '@/assets/homepage/Heading.png';
const categories = [
  'Real Estate',
  'Clinic',
  'Education',
  'F&B',
  'FMCG Client',
  'Furniture',
  'Hotel & Resort',
  'Tech Client'
];

import tech1 from '@/assets/homepage/project/tech1.png';
import tech2 from '@/assets/homepage/project/tech2.png';
import tech3 from '@/assets/homepage/project/tech3.png';
import tech4 from '@/assets/homepage/project/tech4.png';

import fm1 from '@/assets/homepage/project/fm1.png';
import fm2 from '@/assets/homepage/project/fm2.png';
import fm3 from '@/assets/homepage/project/fm3.png';
import fm4 from '@/assets/homepage/project/fm4.png';

import re1 from '@/assets/homepage/project/re1.png';
import re2 from '@/assets/homepage/project/re2.png';
import re3 from '@/assets/homepage/project/re3.png';
import re4 from '@/assets/homepage/project/re4.png';

import fb1 from '@/assets/homepage/project/fb1.png';
import fb2 from '@/assets/homepage/project/fb2.png';
import fb3 from '@/assets/homepage/project/fb3.png';
import fb4 from '@/assets/homepage/project/fb4.png';

import hr1 from '@/assets/homepage/project/hr1.png';
import hr2 from '@/assets/homepage/project/hr2.png';
import hr3 from '@/assets/homepage/project/hr3.png';
import hr4 from '@/assets/homepage/project/hr4.png';

import fur1 from '@/assets/homepage/project/fur1.png';
import fur2 from '@/assets/homepage/project/fur2.png';
import fur3 from '@/assets/homepage/project/fur3.png';
import fur4 from '@/assets/homepage/project/fur4.png';

import cli1 from '@/assets/homepage/project/cli1.png';
import cli2 from '@/assets/homepage/project/cli2.png';
import cli3 from '@/assets/homepage/project/cli3.png';
import cli4 from '@/assets/homepage/project/cli4.png';

import edu1 from '@/assets/homepage/project/edu1.png';
import edu2 from '@/assets/homepage/project/edu2.png';
import edu3 from '@/assets/homepage/project/edu3.png';
import edu4 from '@/assets/homepage/project/edu4.png';

const projects = [
  { title: 'SOUL', desc: 'Thương hiệu tai nghe nổi tiếng', category: 'Tech Client', image: tech3 },
  { title: 'UAG', desc: 'Thương hiệu ốp lưng, đồ điện tử đến từ Mỹ', category: 'Tech Client', image: tech4 },
  {
    title: 'IGLOOHOME',
    desc: 'Igloohome là thương hiệu khóa thông minh và hộp khóa thông minh với giải pháp sáng tạo giúp quản lý và bảo vệ chìa khóa, tài sản.',
    category: 'Tech Client',
    image: tech1
  },
  {
    title: 'AUKEY',
    desc: 'AUKEY là thương hiệu công nghệ nổi tiếng, chuyên sản xuất phụ kiện sạc, cáp, pin dự phòng, tai nghe và loa.',
    category: 'Tech Client',
    image: tech2
  },

  {
    title: 'ANCHOR',
    desc: 'Anchor là thương hiệu lâu đời tại New Zealand hơn 130 năm tuổi, thuộc Fonterra, nổi tiếng với sữa tươi, bơ, phô mai và kem.',
    category: 'FMCG Client',
    image: fm4
  },
  {
    title: 'XMEN',
    desc: 'X-Men là thương hiệu chăm sóc cá nhân nổi tiếng tại Việt Nam, với bộ sản phẩm khử mùi nam tính, khả năng làm sạch sâu và mùi dưỡng tóc độc đáo.',
    category: 'FMCG Client',
    image: fm2
  },
  {
    title: 'LOVITE',
    desc: 'Lovité Paris là thương hiệu mỹ phẩm Pháp nổi tiếng ở thị trường Việt Nam, với các dòng sản phẩm đẹp da chống lão hoá và phục hồi chuyên sâu.',
    category: 'FMCG Client',
    image: fm3
  },
  {
    title: 'Trung Nguyên',
    desc: 'Cà phê Trung Nguyên là thương hiệu hàng đầu Việt Nam từ năm 1996, nổi tiếng với hạt Robusta chất lượng cao.',
    category: 'FMCG Client',
    image: fm1
  },

  {
    title: 'An Gia',
    desc: 'An Gia là công ty bất động sản tại TP.HCM, nổi tiếng với các dự án căn hộ trung và cao cấp tại TP.HCM và vùng lân cận.',
    category: 'Real Estate',
    image: re4
  },
  {
    title: 'Premier Village Phu Quoc',
    desc: 'Premier Village Phú Quốc Resort là khu nghỉ dưỡng do Sun Group, do Accor Hotels quản lý',
    category: 'Real Estate',
    image: re3
  },
  {
    title: 'Pi City',
    desc: 'Picity High Park là khu phức hợp cao cấp rộng 8.8 ha tại Quận 12, TP.HCM, do Pi Group đầu tư',
    category: 'Real Estate',
    image: re2
  },
  {
    title: 'Hung Thinh Group',
    desc: 'Tập đoàn Hưng Thịnh là doanh nghiệp đa ngành với hơn 20 năm kinh nghiệm, nổi bật trong lĩnh vực bất động sản và phát triển hệ sinh thái dịch vụ, công nghệ PropTech, Fintech và kinh doanh số.',
    category: 'Real Estate',
    image: re1
  },

  {
    title: 'The Coffee House',
    desc: 'The Coffee House là một trong những thương hiệu cà phê hàng đầu tại Việt Nam với hơn 107 cửa hàng trải dài khắp cả nước',
    category: 'F&B',
    image: fb1
  },
  {
    title: 'Pho Dinh',
    desc: 'Phở Đỉnh là nhà hàng thuộc hệ thống Uraetei, chuyên về các món thịt nướng chuẩn Nhật.',
    category: 'F&B',
    image: fb2
  },
  {
    title: 'Gogihouse',
    desc: 'Gogi House là chuỗi nhà hàng thịt nướng Hàn Quốc nổi tiếng, với nhiều chi nhánh trên toàn quốc.',
    category: 'F&B',
    image: fb4
  },
  {
    title: 'Póc Póc',
    desc: 'Póc Póc Beer Garden - nhà hàng bia sân vườn tọa lạc tại trung tâm Quận 3',
    category: 'F&B',
    image: fb3
  },

  {
    title: 'Cloud 9 Glamping',
    desc: 'Cloud 9 Glamping - Tour cắm trại sân mây tại Đà Lạt',
    category: 'Hotel & Resort',
    image: hr1
  },
  {
    title: 'Novotel',
    desc: 'Novotel là thương hiệu khách sạn con của tập đoàn Accor, nổi tiếng với dịch vụ chất lượng cao và trải nghiệm lưu trú thoải mái, tiện nghi.',
    category: 'Hotel & Resort',
    image: hr4
  },
  {
    title: 'JW Marriot',
    desc: 'JW Marriott là thương hiệu khách sạn sang trọng thuộc Marriott International, tập đoàn khách sạn hàng đầu thế giới.',
    category: 'Hotel & Resort',
    image: hr2
  },
  {
    title: 'Fusion Resort',
    desc: 'Fusion Resort là thương hiệu thuộc Fusion Hotel Group, nổi tiếng với các khu nghỉ dưỡng độc đáo kết hợp trải nghiệm lưu trú và chăm sóc sức khỏe.',
    category: 'Hotel & Resort',
    image: hr3
  },

  {
    title: 'Saint Gobain',
    desc: 'Saint-Gobain là tập đoàn Pháp với hơn 350 năm lịch sử, chuyên sản xuất và phân phối vật liệu xây dựng cùng các giải pháp liên quan.',
    category: 'Furniture',
    image: fur2
  },
  {
    title: 'Vĩnh Tường',
    desc: 'Vĩnh Tường là thành viên của tập đoàn Saint-Gobain, chuyên cung cấp các giải pháp trần và tường thạch cao, với các giải pháp xây dựng hiện đại.',
    category: 'Furniture',
    image: fur3
  },
  {
    title: 'Kova',
    desc: 'KOVA là nhãn sơn Việt tiên phong ứng dụng công nghệ Nano từ vỏ trấu, mang lại hóa tính năng vượt trội: chống thấm, chống nóng, chống cháy, chống bám bụi,...',
    category: 'Furniture',
    image: fur1
  },
  {
    title: 'BOSCH',
    desc: 'Robert Bosch GmbH là tập đoàn công nghệ hàng đầu thế giới, cung cấp công nghệ ô tô, hàng tiêu dùng, công nghiệp, hàng gia dụng và giải pháp nhà thông minh.',
    category: 'Furniture',
    image: fur4
  },

  {
    title: 'Dr Duy Hai',
    desc: 'Dr Duy Hải - Skin & Laser Clinic là phòng khám da liễu do Th.S.BS. Nguyễn Duy Hải - chuyên khoa Da liễu thẩm mỹ, trực tiếp thực hiện điều trị chuyên môn bám sát lộ trình.',
    category: 'Clinic',
    image: cli3
  },
  {
    title: 'AZ Nose',
    desc: 'AZ Nose - Trung tâm thẩm mỹ chuyên sâu nâng mũi, với đội ngũ y bác sĩ chuyên môn cao.',
    category: 'Clinic',
    image: cli1
  },
  {
    title: 'Dr Care',
    desc: 'Dr. Care - cung cấp dịch vụ trồng răng Implant chuẩn Mỹ với bằng cấp và thiết bị hiện đại, trang thiết bị nhập khẩu.',
    category: 'Clinic',
    image: cli2
  },
  {
    title: 'O2Skin',
    desc: 'O2 SKIN là một trong những phòng khám da liễu nổi tiếng, nổi tiếng với đội ngũ y bác sĩ chuẩn y khoa, được thành lập từ năm 2015.',
    category: 'Clinic',
    image: cli4
  },
  {
    title: 'Wall Street English',
    desc: 'Wall Street English là hệ thống trung tâm tiếng Anh quốc tế từ năm 1972, hiện có mặt tại hơn 30 quốc gia và đã giúp hơn 3 triệu học viên chinh phục tiếng Anh.',
    category: 'Education',
    image: edu1
  },
  {
    title: 'EF Education',
    desc: 'EF Education First (EF) là tổ chức giáo dục quốc tế hàng đầu, thành lập năm 1965 tại Thụy Điển, cung cấp chương trình đào tạo ngoại ngữ kết hợp trao đổi văn hóa, học thuật và thực tập tại hơn 20 quốc gia.',
    category: 'Education',
    image: edu3
  },
  {
    title: 'FTU',
    desc: 'Trường Đại học Ngoại thương (FTU) là đại học công lập trực thuộc Bộ Giáo dục và Đào tạo, nổi tiếng với chất lượng đào tạo về kinh tế, kinh doanh và quản lý.',
    category: 'Education',
    image: edu4
  },
  {
    title: 'DH To Hien Thanh',
    desc: 'Viện Đào tạo Quốc tế NTT (NIIE), là đơn vị viện phòng của Trường Đại học Nguyễn Tất Thành trong công tác Quốc tế hóa Giáo dục Đại học.',
    category: 'Education',
    image: edu2
  }
];

const PROJECTS_PER_PAGE = 4;

function getPageNumbers(total: number, current: number) {
  // Simple pagination: always show all pages for small numbers
  return Array.from({ length: total }, (_, i) => i + 1);
}

const ProjectsSection: React.FC = () => {
  const [page, setPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  // Filter projects by selected category
  const filteredProjects = projects.filter((project) => project.category === selectedCategory);
  const totalPages = Math.ceil(filteredProjects.length / PROJECTS_PER_PAGE);
  const pageNumbers = getPageNumbers(totalPages, page);
  const startIdx = (page - 1) * PROJECTS_PER_PAGE;
  const pagedProjects = filteredProjects.slice(startIdx, startIdx + PROJECTS_PER_PAGE);

  const handlePrev = () => setPage((p) => Math.max(1, p - 1));
  const handleNext = () => setPage((p) => Math.min(totalPages, p + 1));
  const handleTabClick = (cat: string) => {
    setSelectedCategory(cat);
    setPage(1);
  };

  return (
    <section className='relative w-full py-20 max-[560px]:py-8 bg-white z-10'>
      <div className='max-w-6xl mx-auto px-4'>
        <div className='w-full flex items-center justify-center'>
          <motion.img
            src={HeadingIcon}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className='w-[90%] max-w-[1091px] text-center'
          ></motion.img>
        </div>
        {/* Tab Bar */}
        <div className='w-full flex items-center justify-center -mt-[70px] max-[560px]:mt-0 max-[789px]:mt-[-35px]'>
          <div className='w-full  overflow-x-auto no-scrollbar'>
            <div className='flex justify-center px-2 rounded-lg mb-10 pt-2 pb-1 bg-[#F1F5F9] w-fit'>
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => handleTabClick(cat)}
                  className={`px-4 py-2 rounded-[4px] font-medium text-base transition border-none whitespace-nowrap
                ${
                  selectedCategory === cat
                    ? 'bg-[#FFFFFF] text-[#020617] shadow border-gray-200'
                    : 'text-[#64748B] border-gray-200 hover:bg-gray-100'
                }
              `}
                  style={{
                    borderRadius: selectedCategory === cat ? '8.7px' : '2px',
                    boxShadow: selectedCategory === cat ? '0px 1px 2px 0px rgba(0,0,0,0.05)' : 'none'
                  }}
                  aria-current={selectedCategory === cat ? 'page' : undefined}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* Projects Grid */}
        <AnimatePresence mode='wait'>
          <motion.div
            key={page}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
            className='grid grid-cols-2 gap-10 mb-10 max-[768px]:grid-cols-1'
          >
            {pagedProjects.map((project, i) => (
              <div
                key={project.title}
                className='bg-gray-50 rounded-2xl shadow-lg p-6 flex flex-col md:flex-row gap-6 items-center'
              >
                <img src={project.image} alt={project.title} className='w-full object-cover rounded-xl' />
                <div className='flex-1 flex flex-col items-start w-full'>
                  <div className='text-2xl font-normal mb-2 max-[560px]:text-xl'>{project.title}</div>
                  <div className='text-base max-[560px]:text-sm font-normal text-[#98989A] mb-4'>{project.desc}</div>
                  {/* <div className='flex flex-wrap gap-2'>
                    {project.tags.map((tag) => (
                      <span key={tag} className='bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-medium'>
                        {tag}
                      </span>
                    ))}
                  </div> */}
                </div>
              </div>
            ))}
          </motion.div>
        </AnimatePresence>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className='flex justify-center items-center gap-2 select-none'>
            {/* Prev */}
            <button
              onClick={handlePrev}
              disabled={page === 1}
              className={`flex items-center gap-1 px-4 py-2 rounded-md border ${page === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-blue-700 hover:bg-blue-50'} transition`}
              aria-label='Previous page'
            >
              <span className='inline-block w-4 h-4'>
                <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M10 12L6 8L10 4'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </span>
              Previous
            </button>
            {/* Page Numbers */}
            {pageNumbers.map((num) => (
              <button
                key={num}
                onClick={() => setPage(num)}
                className={`w-10 h-10 flex items-center justify-center rounded-lg border text-base font-medium transition ${num === page ? 'bg-blue-600 text-white border-blue-300' : 'bg-white text-blue-700 border border-blue-300 hover:bg-blue-50'}`}
                aria-current={num === page ? 'page' : undefined}
              >
                {num}
              </button>
            ))}
            {/* Next */}
            <button
              onClick={handleNext}
              disabled={page === totalPages}
              className={`flex items-center gap-1 px-4 py-2 rounded-md border ${page === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-blue-700 hover:bg-blue-50'} transition`}
              aria-label='Next page'
            >
              Next
              <span className='inline-block w-4 h-4'>
                <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M6 4L10 8L6 12'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectsSection;
